import { render } from "./InitDon.vue?vue&type=template&id=27e01ace&scoped=true"
import script from "./InitDon.vue?vue&type=script&lang=js"
export * from "./InitDon.vue?vue&type=script&lang=js"

import "./InitDon.vue?vue&type=style&index=0&id=27e01ace&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e01ace"]])

export default __exports__